import {TrekModel} from '@/Pages/Admin/Modules/Models/TrekModel';
import {TrekDepartureModel} from '@/Pages/Admin/Modules/Models/ManagePackage/Tab/Departure/TrekDepartureModel';
import {CustomerModel} from '@/Pages/Admin/Modules/Models/ManagePackage/Tab/Reviews/CustomerModel';
import {AccountModel} from '@/Pages/Admin/Modules/Models/ManageAccount/AccountModel';

export class TrekBookingModel {
    protected id: number;
    protected uuid: string;
    protected account_id: number;
    protected customer_id: number;
    protected trek_id: number;
    protected departure_id: number;
    protected no_of_infant: number;
    protected no_of_youth: number;
    protected no_of_adult: number;
    protected total_no_of_travellers: number;
    protected type: string;
    protected total_price: string;
    protected saved_price: string;
    protected is_paid: number;
    protected payment_method: string;
    protected paid_date: string;
    protected paid_remarks: string;
    protected booking_remarks: string;
    protected created_at: string;
    protected updated_at: string;
    protected booking_customer_id: number;
    protected title: string;
    protected email: string;
    protected firstname: string;
    protected lastname: string;
    protected contact_number: string;
    protected trek: TrekModel = new TrekModel({});
    protected departure: TrekDepartureModel = new TrekDepartureModel({});
    protected customer: CustomerModel = new CustomerModel({});
    protected account: AccountModel = new AccountModel({});

    constructor(obj: any) {
        this.id = obj.id ? obj.id : 0;
        this.uuid = obj.uuid ? obj.uuid : '';
        this.account_id = obj.account_id ? obj.account_id : 0;
        this.customer_id = obj.customer_id ? obj.customer_id : 0;
        this.trek_id = obj.trek_id ? obj.trek_id : 0;
        this.departure_id = obj.departure_id ? obj.departure_id : 0;
        this.no_of_infant = obj.no_of_infant ? obj.no_of_infant : 0;
        this.no_of_youth = obj.no_of_youth ? obj.no_of_youth : 0;
        this.no_of_adult = obj.no_of_adult ? obj.no_of_adult : 0;
        this.total_no_of_travellers = obj.total_no_of_travellers ? obj.total_no_of_travellers : 0;
        this.type = obj.type ? obj.type : '';
        this.total_price = obj.total_price ? obj.total_price : '';
        this.saved_price = obj.saved_price ? obj.saved_price : '';
        this.is_paid = obj.is_paid ? obj.is_paid : 0;
        this.payment_method = obj.payment_method ? obj.payment_method : '';
        this.paid_date = obj.paid_date ? obj.paid_date : '';
        this.paid_remarks = obj.paid_remarks ? obj.paid_remarks : '';
        this.booking_remarks = obj.booking_remarks ? obj.booking_remarks : '';
        this.created_at = obj.created_at ? obj.created_at : '';
        this.updated_at = obj.updated_at ? obj.updated_at : '';
        this.booking_customer_id = obj.booking_customer_id ? obj.booking_customer_id : 0;
        this.title = obj.title ? obj.title : '';
        this.email = obj.email ? obj.email : '';
        this.firstname = obj.firstname ? obj.firstname : '';
        this.lastname = obj.lastname ? obj.lastname : '';
        this.contact_number = obj.contact_number ? obj.contact_number : '';
        this.trek = obj.trek ? obj.trek : new TrekModel({});
        this.departure = obj.departure ? obj.departure : new TrekDepartureModel({});
        this.customer = obj.customer ? obj.customer : new CustomerModel({});
        this.account = obj.account ? obj.account : new AccountModel({});
    }
}


